<template>
  <div class="zhuangban">
    <div class="zhuangbanbg">
      <appHeader activeIndex="zhuangban" ></appHeader>
      <div class="zhuangbanContent">
        <!-- 介绍 -->
        <div class="zhuangbanInfo">
          <div class="zhuangbanInfo1">
            <img class="zhuangbanInfo1Img1" src="../../assets/img/Product/zhuangban.png"  alt />
            <br>
            <img class="zhuangbanInfo1Img2"  src="../../assets/img/products/zhuangban/zhuangbanQRcode.png" alt />
            <div>扫描二维码下载</div>     
          </div>
          <div class="zhuangbanInfo2">
            <img src="../../assets/img/products/zhuangban/zhuangbanFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p class="zhuangbanInfo2Font">四位小公主的生日马上就要到了，为了给她们一个难忘的回忆，我们决定要为公主们穿上漂亮的裙装！首先我们需要选择一位公主，并且为她挑选合适的衣服，同时进行场景搭配，让公主能够美美的拍个照！四位公主的造型和服装都各有特色，我们可以根据自己的喜好去为她们穿搭哦！快来把公主们打扮的美丽一些吧，为她们的生日派对做好充足的准备！
装扮小女孩，让小公主成为闪亮的一颗星吧！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="zhuangbanCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="zhuangbanWrap">
            <div class="zhuangbanMainImg" :style="{ left: nowLeft + '%' }">
              <img class="zhuangbanCarouselImg"   src="../../assets/img/products/zhuangban/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
       left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/zhuangban.css";
</style>
